import React, {FC, useEffect} from 'react';
import {connect} from "react-redux";
import WrapperPreloader from "../../components/WrapperPreloader";
import {getInfoBrand, handleIdMix, setLoadingTrue} from '../../modules/TastesBrand';
import TastesBrand from "../../components/Mixer/TastesBrand";
import { withRouter } from 'react-router-dom';

interface ITastesBrandPage {
    isLoading: boolean,
    tastesBrand: Array<object>,
    getInfoBrand: any,
    match: any,
    handleTastes: any,
    tastes: Array<number>,
    setLoadingTrue: any
}

const TastesBrandPage: FC<ITastesBrandPage> = ({
                                                   isLoading,
                                                   tastesBrand,
                                                   getInfoBrand,
                                                   match,
                                                   handleTastes,
                                                   tastes,
                                                   setLoadingTrue
                                               }) => {
    useEffect(() => {
        const {id} = match.params;
        getInfoBrand(+id);
        return () => setLoadingTrue()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WrapperPreloader
            isLoading={isLoading}
        >
            <TastesBrand
                tastesID={tastes}
                tastesBrand={tastesBrand}
                handleMix={handleTastes}
            />
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.tastesBrand.isLoading,
    tastesBrand: state.tastesBrand.activeInfoBrand,
    tastes: state.tastesBrand.tastes,
});

const mapDispatchToProps = (dispatch: any) => ({
    getInfoBrand: (id: number) => dispatch((getInfoBrand(id))),
    setLoadingTrue: () => dispatch(setLoadingTrue()),
    handleTastes: (id: number, name: string, brandName: string, isActive: boolean) => dispatch(handleIdMix(id, name, brandName, isActive)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TastesBrandPage))

